import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  error: null,
  appliedMenus: [],
  deleting: false,
  deleteSuccessful: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_APPLIED_MENUS_DELETE_SUCCESSFUL:
      return {
        ...state,
        deleteSuccessful: payload,
      };

    case types.DELETE_APPLIED_MENUS_FETCHING:
      return {
        ...state,
        deleting: payload,
      };

    case types.GET_APPLIED_MENUS:
      return {
        ...state,
        fetching: payload,
      };

    case types.SET_APPLIED_MENUS:
      return { ...state, appliedMenus: payload };

    case types.DELETE_APPLIED_MENUS_ERROR:
    case types.GET_APPLIED_MENUS_ERROR:
      return { ...state, error: payload };

    case types.CLEAR_APPLIED_MENUS_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/listappliedmenus/reducer.js